<template>
  <div>
    <module-card title="筛选">
      <el-form :model="searchForm" :inline="true">
        <el-form-item label="打款日期">
          <date-range-picker :value="inputTime" @getChange="value => inputTime = value"
            :maxRange="30" :clearable="false"></date-range-picker>
        </el-form-item>
        <el-form-item label="商户号">
          <el-input v-model.trim="searchForm.merchantId" placeholder="请输入商户号" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item label="打款单号">
          <el-input v-model.trim="searchForm.disburseId" placeholder="请输入打款单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="打款状态">
          <el-select v-model="searchForm.state" class="form-input" clearable>
            <el-option v-for="item in remitStatusList" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="银行">
          <el-select v-model="searchForm.cardBank" class="form-input" clearable>
            <el-option value label="全部"></el-option>
            <el-option v-for="item in bankList" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="searchLoading" @click="searchBtnClick">查询</el-button>
          <el-button type="primary" icon="el-icon-download" :loading="exportLoading" @click="exportBtnClick">导出</el-button>
        </el-form-item>
      </el-form>
    </module-card>
    <module-card title="银行补贴打款明细">
      <p style="margin-bottom: 20px;">打款金额（元）：{{ countAmount }}</p>
      <el-table border :data="tableData" v-loading="searchLoading">
        <el-table-column v-for="item in columns" :label="item.label" :prop="item.key" :key="item.key"></el-table-column>
        <!-- <el-table-column label="操作">
          <template slot-scope="scope">
            <auth-button auth-type="span" opt="sync_status" label="同步状态" @click.native="syncStatus(scope.row)"></auth-button>
          </template>
        </el-table-column> -->
      </el-table>
      <pagination :count="total" :edit-size="true" :page-no="pageNo" :size="pageSize"
        @changePage="value => { pageNo = value; getTableList() }"
        @changeSize="value => { pageSize = value; pageNo = 1; getTableList() }"></pagination>
    </module-card>
  </div>
</template>

<script>
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { formateDate, downJumpConfirm } from '@/assets/js/utils'
export default {
  name: 'bankSubsidyRemitDetail',
  components: { dateRangePicker, pagination },

  data () {
    return {
      inputTime: [],
      searchForm: {
        cardBank: '',
        merchantId: '',
        disburseId: '',
        state: '',
        startTime: '',
        endTime: ''
      },
      remitStatusList: [
        { text: '全部', value: '' },
        { text: '初始化状态', value: 0 },
        { text: '金额冻结成功', value: 1 },
        { text: '金额冻结失败', value: 2 },
        { text: '冻结结果未知', value: 3 },
        { text: '商户打款禁用', value: 4 },
        { text: '被拦截<未发起付款>', value: 5 },
        { text: '打款中', value: 6 },
        { text: '付款成功', value: 7 },
        { text: '付款失败', value: 8 },
        { text: '金额解冻转账成功', value: 9 },
        { text: '金额解冻转账失败', value: 10 },
        { text: '金额解冻转账结果未知', value: 11 },
        { text: '金额解冻成功', value: 12 },
        { text: '金额解冻失败', value: 13 },
        { text: '金额解冻结果未知', value: 14 },
        { text: '退票成功', value: 15 },
        { text: '退票失败', value: 16 },
        { text: '退票结果未知', value: 17 },
        { text: '打款单被合并', value: 18 },
        { text: '提交打款失败，允许重新打款', value: 19 },
        { text: '申请退票', value: 20 },
        { text: '止付请求状态未知', value: 21 },
        { text: '禁止结算商户资金转移成功', value: 22 },
        { text: '禁止结算商户资金转移未知', value: 23 },
        { text: '金额转账成功', value: 24 },
        { text: '金额转账未知', value: 25 }
      ],
      bankList: [],
      columns: [
        { label: '打款时间', key: 'createTime' },
        { label: '打款单号', key: 'disburseId' },
        { label: '银行名称', key: 'cardBank' },
        { label: '商户编号', key: 'merchantId' },
        { label: '商户简称', key: 'merchantName' },
        { label: '一代编号', key: 'topAgentId' },
        { label: '一代名称', key: 'topAgentName' },
        { label: '直属代理商编号', key: 'agentId' },
        { label: '直属代理商名称', key: 'agentName' },
        { label: '入账人姓名', key: 'payeeName' },
        { label: '银行卡号', key: 'bankAccount' },
        { label: '支行', key: 'subBank' },
        { label: '打款金额（元）', key: 'amount' },
        { label: '打款状态', key: 'state' },
        { label: '结算账户类型', key: 'settlementType' },
        { label: '税点比例', key: 'taxRate' },
        { label: '扣税金额（元）', key: 'taxAmount' },
        { label: '补贴日期', key: 'subsidyDate' }
      ],
      countAmount: '',
      searchLoading: false,
      exportLoading: false,
      tableData: [{ activityName: 1 }],
      pageNo: 1,
      pageSize: 10,
      total: 0
    }
  },
  computed: {},

  mounted () {
    const endTime = formateDate(new Date()).substring(0, 10) + ' 23:59:59'
    const startTime = formateDate(new Date(new Date().getTime() - 3600 * 1000 * 24 * 29)).substring(0, 10) + ' 00:00:00'
    this.inputTime = [startTime, endTime]
    this.searchBtnClick()
    this.getBankList()
  },

  methods: {
    searchBtnClick () {
      this.pageNo = 1
      this.getTableList()
    },
    getBankList () {
      this.$axios.post(this.$api.getSubsidyBankList, {}).then(res => {
        if (res.respCode === '0') {
          this.bankList = res.data?.map(item => ({ text: item, value: item })) || []
        }
      })
    },
    exportBtnClick () {
      const params = {
        ...this.searchForm,
        startTime: this.inputTime && this.inputTime.length ? this.inputTime[0] : '',
        endTime: this.inputTime && this.inputTime.length ? this.inputTime[1] : ''
      }
      this.exportLoading = true
      this.$axios.post(this.$api.exportDisbursementList, params).then(res => {
        this.exportLoading = false
        if (res.respCode === '0') {
          downJumpConfirm.call(this)
        }
      })
    },
    getTableList () {
      const params = {
        ...this.searchForm,
        startTime: this.inputTime && this.inputTime.length ? this.inputTime[0] : '',
        endTime: this.inputTime && this.inputTime.length ? this.inputTime[1] : '',
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.tableData = []
      this.total = 0
      this.searchLoading = true
      this.$axios.post(this.$api.getDisbursementList, params).then(res => {
        this.searchLoading = false
        if (res.respCode === '0') {
          this.countAmount = res.data.countAmount
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.tableData = []
          this.total = 0
        }
      })
    }
    // syncStatus (row) {
    //
    // }
  }
}
</script>
<style lang='css' scoped></style>
